import { customAxios, customPatchAxios } from "./customAxios";

/**
 * 역사 전체 목록
 * @returns 
 */
export const getStationsAll = async()=>{
  const res = await customAxios.get('/api/stations');
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * 역사 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getStationsByQuery = async(query)=>{
 const res = await customAxios.get('/api/stations', {params : query});
 if (res.data) {
    return res.data;
 }
 return null;
}


/**
 * 역사 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getStationsByQueryString = async(queryString)=>{
  const res = await customAxios.get('/api/stations'+queryString);
  if (res.data) {
     return res.data;
  }
  return null;
 }

/**
 * 파트 등록
 * @param {*} body 
 */
export const postStations = async(body)=>{
  //console.log(body);
  await customAxios.post('/api/stations',body);
}

/**
 * 파트 수정
 * @param {*} body 
 */
export const patchStations = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/stations/'+body.id, body);
}

/**
 * 파트 삭제
 * @param {*} param 
 */
export const deleteStations = async(param)=>{
  //console.log(param);
  await customAxios.delete('/api/stations/'+param);
}

/**
* 역사 개수
* @returns 
*/
export const getStationsCount = async(query)=>{
  const res = await customAxios.get('/api/stations/count', {params : query});
  //console.log(res);
  if (res) {
     return res.data;
  }
  return null;
}